import React from 'react';
import messages from '../../../../../text/messages';
import CompanyInformationStep from './companyInformation';
import BillingStep from './billing';
import ProgramPoliciesStep from './programPolicies';

export function getSteps(controls, progress, props) {
    let rest = { ...props, ...controls };
    let moveTo = to => () => controls.next(to, props.client.id, progress.branch);

    return [
        <CompanyInformationStep onSubmit={moveTo(1)} message={messages.companyInformation} {...rest} />,
        <BillingStep message={messages.companyBillingAndAch} onSubmit={moveTo(2)} {...rest} />,
        <ProgramPoliciesStep message={messages.companyProgramPolicies} {...rest} />
    ];
}



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/client/steps/index.jsx